import React, { useEffect, useState } from "react";
import { searchClient, SITE_INDEX_HE } from "assets/constants";


export interface AlgoliaHit2 {
  objectID: string;
  title: string; // Adjust this type based on your data structure
  name: string;
  hebrewName: string;
  url: string;
  objectType: string;
  _highlightResult?: any;
  _snippetResult?: any;
  _rankingInfo?: any;
  _distinctSeqID?: number;
  serviceName: string;
}

export const useClickOutside = (
  ref: React.RefObject<HTMLDivElement>,
  onClickOutside: Function,
  id?: string
) => {
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        (!id || id !== event.target.id)
      ) {
        onClickOutside();
      }
    };
    document.addEventListener("mouseup", handleClickOutside);
    return () => document.removeEventListener("mouseup", handleClickOutside);
  }, [ref, onClickOutside]);
};

export function useAutocomplete(query: string, filters?: string, indexName?: string, restrictSearchableAttributes?: string[]) {  
  const [hits, setHits] = useState<AlgoliaHit2[]>([]);
  const index = searchClient.initIndex(indexName || SITE_INDEX_HE);
  useEffect(() => {
    let regex = /[a-zA-Z\u0590-\u05FF]/; //original
    //let regex = /[a-zA-Z\u0590-\u05FF0-9]/; //added option to search for numbers as well
    if (query.length > 2 && regex.test(query)/*!query.includes("@")*/) {
      index
        .search<AlgoliaHit2>(query, {
          hitsPerPage: 50, // Set the number of results you want to retrieve
          filters, // Apply filters here
          restrictSearchableAttributes,
        })
        .then(({ hits }) => {
          setHits(hits);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setHits([]);
    }
  }, [query, filters]);

  return { hits };
}